import {flow, Instance, SnapshotIn, SnapshotOut, types} from "mobx-state-tree";
import {serializeImportSkillsData} from "./serializers";
import {deserializeSkills} from "./deserializer";
import {SkillsApi} from "../../../api/questions/SkillsApi";
import {PageQuery} from "../../../api/questions/typings";
import {snackbarStore} from "../../ui/SnackbarStore";

export interface ImportSkillsData {
    filename: string;
}

export const SkillModel = types.model({
    id: types.identifier,
    title: types.string,
    order: types.number,
    created_at: types.string,
    updated_at: types.string,
});

export const SkillsModel = types
    .model({
        skills: types.array(SkillModel),
        page: types.model({
            current_page: types.maybe(types.number),
            from: types.maybe(types.number),
            last_page: types.maybe(types.number),
            per_page: types.maybe(types.number),
            to: types.maybe(types.number),
            total: types.maybe(types.number),
        })
    })
    .actions((self) => {
        const importSkills = flow(function* (filename: ImportSkillsData) {
            const serializedImportSkillsData = serializeImportSkillsData(filename);
            const response = yield SkillsApi.importSkills(serializedImportSkillsData);
            self.skills = deserializeSkills(response);
            snackbarStore.notifySuccess(`Импорт завершен! Всего навыков в базе: ${self.skills.length}`)
        });

        const getSkills = flow(function* (query: PageQuery = {}) {
            const response = yield SkillsApi.getSKills(query);
            const { page } = response.meta;
            if (page) {
                self.page = response.meta.page;
            }
            self.skills = deserializeSkills(response);
        })

        return {
            importSkills,
            getSkills,
        };
    })
    .views((self) => ({
        get getSkillsTableData() {
            return self.skills.map(({ id, title, order }) => ({ id, title, order }))
        },
        get getSkillsData() {
            return self.skills;
        }
    }));

export interface Skills extends Instance<typeof SkillsModel> {
}
export interface Skill extends Instance<typeof SkillModel> {
}
export interface SkillSnapshotIn extends SnapshotIn<typeof SkillModel> {
}
export interface SkillSnapshotOut extends SnapshotOut<typeof SkillModel> {
}

